import { useMutation } from '@apollo/client';
import { FRONTEND_TYPE_TO_PROVIDER_TYPE } from '@application/api/account/useCurrentAccount/constants';
import { useRouter, useShowToast } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  MtSocialProvidersUnlinkAccountMutation,
  MtSocialProvidersUnlinkAccountMutationVariables,
} from '@gql/graphql';
import type { MtSocialProviderType } from '@presentation/components';
import { useCallback } from 'react';
import { MT_SOCIAL_PROVIDERS_ACCOUNT_PROVIDERS } from './useAccountProviders';

export const MT_SOCIAL_PROVIDERS_UNLINK_ACCOUNT = graphql(`
  mutation MtSocialProvidersUnlinkAccount($type: AuthTokenInfoType!) {
    unlinkAccount(type: $type) {
      id
    }
  }
`);

export const useUnlinkAccount = () => {
  const { translate } = useRouter();
  const { showToast } = useShowToast();

  const [unlink, { data, error, loading }] = useMutation<
    MtSocialProvidersUnlinkAccountMutation,
    MtSocialProvidersUnlinkAccountMutationVariables
  >(MT_SOCIAL_PROVIDERS_UNLINK_ACCOUNT, {
    awaitRefetchQueries: true,
    refetchQueries: [MT_SOCIAL_PROVIDERS_ACCOUNT_PROVIDERS],
  });

  const unlinkAccount = useCallback(
    async (rawType: MtSocialProviderType) => {
      const type = FRONTEND_TYPE_TO_PROVIDER_TYPE[rawType];
      await unlink({ variables: { type } });
      showToast(translate('common.toasts.unlinkAccount'), {
        type: 'success',
      });
    },
    [showToast, translate, unlink],
  );

  return {
    unlinkAccount,
    unlinkAccountLoading: loading,
    unlinkAccountError: error,
  };
};
